import Image from "next/image"

export const ImageBackground = (props: any) => {
  return (
    <div style={{ backgroundColor: "#E6E6E6" }}>
      <Image {...props} />
    </div>
  )
}
